import Ai1 from '../Assets/images/PNG/Form_Ai/CertiScore.png'
import Ai3 from '../Assets/images/PNG/Form_Ai/Reporting.png'
import Ai4 from '../Assets/images/PNG/Form_Ai/RiskImprovement.png'
import Ai2 from '../Assets/images/PNG/Form_Ai/ClientSupport.png'




export const Form_Ai_data =[
    {
        id:1,
        Image:`${Ai1}`,
        title:'CertiScore',
        desc:"Unlock valuable insights with CertiScore, our AI-powered quality score that provides an instant assessment of your client's form accuracy and completeness."
    },
    {
        id:2,
        Image:`${Ai2}`,
        title:'Client Support',
        desc:"Say goodbye to back-and-forth with your clients. Our AI assisted support technology helps clients fill forms correctly the first time. "
    },
    {
        id:3,
        Image:`${Ai3}`,
        title:'Reporting',
        desc:"Make data-driven decisions with detailed reports that provide you with a comprehensive understanding of your clients' insurance needs. "
    },
    {
        id:4,
        Image:`${Ai4}`,
        title:'Risk Improvement',
        desc:"We analyse vast amounts of data to identify potential risks in insurance applications, and also providing clients with actionable insights on how to reduce their exposures."
    }
]